export const OPERATIONS_EMAIL = 'operations@novaadulthockey.com'

export { PAYMENT_ETRANSFER_EMAIL, SINGLE_GAME_PRICE_CAD } from './paymentContacts'
